var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCcButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_28",
    "data-name": "Artwork 28",
    transform: "translate(22.5 22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218",
    transform: "translate(-22.5 -22.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 21.6,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    transform: "translate(6.183 10.448)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.44
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.634,
    height: 24.103,
    rx: 4.58,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.72,
    y: 0.72,
    width: 31.194,
    height: 22.663,
    rx: 3.86,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "CC",
    transform: "translate(8.788 12.359)",
    fontSize: 18.017,
    fontFamily: "Impact",
    letterSpacing: "0.14em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 2.475,
    y: 18
  }, "CC"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcButton);
export default __webpack_public_path__ + "static/media/cc-button.f62cddfdc054b66e07fc24da67c0cf7c.svg";
export { ForwardRef as ReactComponent };